import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { getVisaAllocation } from "../../../../store/Api/visaStockAPI";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";

export default function Visareturnfromstock({
  showPromptElement,
  setPopUpopen,
  propData,
  setApiTrigger
}) {
  const [visaCount, setVisaCount] = useState('');
  const Nodetoken = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();

  // unstamped = allocated - stamped  (allocated but not yet physically stamped)
  // canBeReversed = min(allocated, unstamped) — only undeployed visas can be reversed
  const allocated     = parseInt(propData?.allocated    || 0);
  const stamped       = parseInt(propData?.stamped_count || 0);
  const unstamped     = allocated - stamped;
  const canBeReversed = Math.min(allocated, unstamped);

  const onSubmit = async () => {
    const count = parseInt(visaCount);

    if (!count || count <= 0) {
      dispatch(setAppError({ msg: "Reverse count must be greater than 0" }));
      return;
    }

    if (canBeReversed <= 0) {
      dispatch(setAppError({ msg: "No visas available to reverse." }));
      return;
    }

    if (count > canBeReversed) {
      dispatch(setAppError({
        msg: `Only ${canBeReversed} visa(s) can be reversed (allocated: ${allocated}, stamped: ${stamped}, unstamped: ${unstamped})`
      }));
      return;
    }

    try {
      const response = await nodeinstance.put(
        `/dashboard/vrr-visa/visareturnfromstock/${propData.vrf_id}`,
        { count, project_id: propData.project_id },
        { headers: { Authorization: `Bearer ${Nodetoken}` } }
      );

      if (response.status === 200) {
        dispatch(getVisaAllocation(Nodetoken));
        dispatch(setAppError({ msg: "Updated successfully", color: "success" }));
        setPopUpopen(false);
        setApiTrigger(true);
      }
    } catch (error) {
      console.error("visareturnfromstock error", error);
      dispatch(setAppError({ msg: error?.response?.data?.message || "Failed to reverse visas" }));
    }
  };

  return (
    <div className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${showPromptElement ? "flex" : "hidden"}`}>
      <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">

        {/* Header */}
        <div className="flex justify-between items-center w-full mb-3">
          <h2 className="text-sm font-semibold text-gray-700">VISA REVERSE FROM STOCK</h2>
          <IoMdClose className="cursor-pointer text-lg" onClick={() => setPopUpopen(false)} />
        </div>

        {/* Info row */}
        <div className="grid grid-cols-3 gap-2 mb-4 text-xs text-center">
          <div className="bg-gray-50 border rounded p-2">
            <p className="text-gray-500">Allocated</p>
            <p className="font-semibold text-gray-800">{allocated}</p>
          </div>
          <div className="bg-gray-50 border rounded p-2">
            <p className="text-gray-500">Stamped</p>
            <p className="font-semibold text-gray-800">{stamped}</p>
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded p-2">
            <p className="text-blue-600">Can Reverse</p>
            <p className="font-semibold text-blue-800">{canBeReversed}</p>
          </div>
        </div>

        {/* Input */}
        <div className="flex flex-col gap-1 w-full mb-4">
          <label className="text-xs text-gray-600">
            VISA REVERSE COUNT <span className="text-gray-400">(max: {canBeReversed})</span>
          </label>
          <input
            type="number"
            min={1}
            max={canBeReversed}
            value={visaCount}
            className="border border-gray-300 rounded-md p-1 py-2 text-xs"
            onChange={(e) => setVisaCount(e.target.value)}
          />
        </div>

        {/* Submit */}
        <div className="flex gap-3 w-full justify-center">
          <button
            className="w-full max-w-xs py-2 px-5 rounded-md ring-1 ring-red text-white bg-red disabled:opacity-50"
            disabled={canBeReversed <= 0}
            onClick={onSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
